import { apiFetch, getCoreApiBaseUrl } from "@justhome/api-runtime";
import { ProjectupdateContext } from "./projectupdateContext";

const pathPrefix = "/project-update";

const getBaseUrl = () => `${getCoreApiBaseUrl()}${pathPrefix}`;

export type ErrorWrapper<TError> =
  | TError
  | (Record<string, unknown> & {
      status: number;
    });

export type ProjectupdateFetcherOptions<TBody, THeaders, TQueryParams, TPathParams> = {
  url: string;
  method: string;
  body?: TBody;
  headers?: THeaders;
  queryParams?: TQueryParams;
  pathParams?: TPathParams;
  signal?: AbortSignal;
} & ProjectupdateContext["fetcherOptions"];

export async function projectupdateFetch<
  TData,
  TError,
  TBody extends {} | FormData | undefined | null,
  THeaders extends {},
  TQueryParams extends {},
  TPathParams extends {},
>(
  options: ProjectupdateFetcherOptions<TBody, THeaders, TQueryParams, TPathParams>,
): Promise<TData> {
  return apiFetch({
    ...options,
    name: "projectupdate",
    baseUrl: getBaseUrl(),
  });
}
